import { useMemo } from "react";
import { showDenominations } from "../utils";
import colors from "../../../../theme/Colours";
import DashboardListCard from "../../../../common/dashboard/DashboardListCard";

export default function TopClientsByVolume({
  data,
}: {
  data: {
    key: string;
    name: string;
    details: {
      period: string;
      name: string;
      values: {
        client_name: string;
        pincode: string;
        sale_amt: string;
        sale_qty: string;
        previous_month_percent?: string;
      }[];
    }[];
  };
}) {
  const items = useMemo(() => {
    if (!data?.details?.length) return [];
    const current = data.details[0];

    return current.values.map((client, index) => {
      const isTopClient = index === 0;
      const saleQtyLiters = `${showDenominations(Number(client.sale_qty))}L`;
      const saleAmount = showDenominations(Number(client.sale_amt), true);

      const raw = parseFloat(String(client.previous_month_percent ?? ""));

      let isPositive: boolean | null = null;
      if (Number.isFinite(raw)) {
        if (raw > 0) {
          isPositive = true;
        } else if (raw < 0) {
          isPositive = false;
        } else {
          isPositive = null;
        }
      }

      return {
        title: client.client_name,
        subtitle: client.pincode,
        rightTop: saleQtyLiters,
        rightBottom: saleAmount,
        helperText: client.previous_month_percent,
        isPositive,
        backgroundColor: isTopClient
          ? colors.salesAnalyticsCardTopClientBg
          : colors.greyBorder,
      };
    });
  }, [data]);

  return <DashboardListCard title={data?.name} items={items} />;
}
